import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fzhauptklasse-list-view',
  imports: [],
  templateUrl: './fzhauptklasse.list-view.html',
  styleUrls: ['./fzhauptklasse.list-view.css'],
})
export class FzhauptklasseListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
